import { render, staticRenderFns } from "./informacionOfertaTabs.vue?vue&type=template&id=60d79d1a&"
import script from "./informacionOfertaTabs.vue?vue&type=script&lang=js&"
export * from "./informacionOfertaTabs.vue?vue&type=script&lang=js&"
import style0 from "./informacionOfertaTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports